import {remCalc} from '_themeUtils'

const searchResults = {
    SearchResults: {
        baseStyle: () => ({
            mainGrid: {
                templateColumns: {base: '1fr', lg: '3fr 2fr'},
                gap: 'spacing.10',
            },
            leftGrid: {
                templateColumns: {base: '1fr', lg: '3fr 4fr 1px 3fr'},
                gap: 'spacing.10',
            },
            columnTitle: {
                textStyle: 'paragraphXs',
                letterSpacing: remCalc(3),
                textTransform: 'uppercase',
                fontWeight: 400,
                mb: 'spacing.6',
            },
            suggestionLabel: {
                textStyle: 'paragraphSm',
                letterSpacing: remCalc(0.6),
                color: 'color.text.grey.600',
                mb: {base: 'spacing.4', lg: 'spacing.6'},
            },
            suggestionLink: {
                color: 'color.text.black',
                textStyle: 'paragraphSm',
            },
            searchedLabel: {
                textStyle: 'paragraphSm',
                mb: {base: 'spacing.9', lg: 0},
            },
            gridDivider: {
                border: `${remCalc(1)} solid`,
                borderColor: 'color.border.header.default',
            },
            storyImages: {
                gap: 'spacing.4',
            },
            ideasList: {
                gap: 'spacing.3',
                align: 'flex-end',
            },
            suggestionText: {
                color: '#6F6F6F99',
                transition: 'all .2s ease-in-out',
                _hover: {
                    color: 'color.text.black',
                },
            },
            searchText: {
                color: 'color.text.black',
            },
        }),
    },
}

export default searchResults
